import { environment } from 'environments/environment';
import { EventEmitter, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { IClassRequest } from '../models/class-request.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardHub {

  public connectionEstablished: EventEmitter<Boolean>;
  public connectionExists: Boolean;
  public createNewRequest: EventEmitter<IClassRequest>;
  private chatConnection: signalR.HubConnection;

  constructor() {
    this.connectionEstablished = new EventEmitter<Boolean>();
    this.connectionExists = false;
    this.createNewRequest = new EventEmitter<IClassRequest>();

    // Создаем подключение к современному SignalR Hub
    this.chatConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.api + 'hubRequestDashboard', {
        transport: signalR.HttpTransportType.ServerSentEvents,
        withCredentials: false // Для CORS с credentials
      })
      .withAutomaticReconnect()
      .build();

    this.registerOnServerEvents();
  }

  public connectToDashboard(clubId: string) {
    this.startConnection(clubId);
  }

  public disconnect() {
    this.chatConnection.stop();
  }

  private async startConnection(clubId: string): Promise<void> {
    if (this.connectionExists) {
      await this.chatConnection.stop();
    }

    try {
      await this.chatConnection.start();
      await this.chatConnection.invoke('subscribeClubDashboard', { clubId });
      this.connectionEstablished.emit(true);
      this.connectionExists = true;
    } catch (error) {
      console.error('DashboardHub connection error:', error);
      this.connectionEstablished.emit(false);
    }
  }

  private registerOnServerEvents(): void {
    // Удаляем старые обработчики и добавляем новые
    this.chatConnection.off('createNewRequest');
    this.chatConnection.on('createNewRequest', (data: IClassRequest) => {
      this.onCreateRequest(data);
    });
  }

  private onCreateRequest = (data: IClassRequest) => {
    this.createNewRequest.emit(data);
  };
}
